/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'ptc.pm.collaborators.title': 'Vaši spolupracovníci',
  'ptc.pm.error-heading': 'Něco se pokazilo',
  'ptc.pm.error-image-alt-text': 'Rozbitý robot a lidé, kteří usilovně pracují na jeho opravě.',
  'ptc.pm.error-text': 'Tyto chyby sledujeme, ale klidně se na nás obraťte, pokud obnovení stránky problém nevyřeší.',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} člen} few {{memberCount,number} členové} many {{memberCount,number} člena} other {{memberCount,number} členů}}',
  'ptc.pm.people': 'Lidé',
  'ptc.pm.teams': 'Týmy',
  'ptc.pm.view-your-profile': 'Zobrazit váš profil',
  'ptc.pm.your-teams.title': 'Vaše týmy',
};
